import * as React from 'react';

const SvgLowTemp = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.33 177.67" {...props}>
		<path
			d="M8.03 157.05c0-9.9 5.66-18.46 13.93-22.67l.05-78.77h-8.09v73.95C5.66 133.77 0 142.33 0 152.24c0 10.94 6.92 20.25 16.61 23.83-5.25-4.66-8.58-11.45-8.58-19.01Z"
			style={{
				fill: '#bbe3f8',
			}}
		/>
		<path
			d="M22.04.56c-4.69 1.46-8.12 5.78-8.12 10.95v44.1H22L22.04.56Z"
			style={{
				fill: '#fff',
			}}
		/>
		<path
			d="m22 55.61-.05 78.77c-8.26 4.21-13.93 12.77-13.93 22.67 0 7.56 3.33 14.35 8.58 19.01 2.76 1.02 5.72 1.61 8.83 1.61 14.05 0 25.44-11.39 25.44-25.44 0-9.91-5.67-18.46-13.93-22.68V55.61H21.99Z"
			style={{
				fill: '#5ebae9',
			}}
		/>
		<path
			d="M25.44 0c-1.19 0-2.32.22-3.4.56L22 55.61h14.95v-44.1C36.95 5.15 31.79 0 25.44 0Z"
			style={{
				fill: '#bdc4ce',
			}}
		/>
		<path
			d="M72.58 135.78v-4.74c0-1.02-1.1-1.65-1.98-1.15l-4.15 2.37c-.63.36-1.44.14-1.8-.49-.37-.64-.15-1.45.49-1.81l6.79-3.9c.41-.24.66-.67.66-1.15v-9.73c0-1.02-1.11-1.66-1.99-1.15l-8.42 4.88c-.41.24-.66.67-.66 1.15v7.8c0 .73-.59 1.32-1.32 1.32h-.04c-.73 0-1.32-.59-1.32-1.32v-4.76c0-1.02-1.11-1.66-1.99-1.15l-4.1 2.38a1.325 1.325 0 0 1-1.33-2.29l4.11-2.38c.88-.51.88-1.79 0-2.3l-4.1-2.36c-.63-.36-.85-1.17-.49-1.8v-.02c.38-.64 1.19-.86 1.83-.49l6.75 3.9c.41.24.91.24 1.32 0l8.45-4.85c.89-.51.89-1.79 0-2.3l-8.45-4.85c-.41-.23-.91-.23-1.32 0l-6.76 3.88c-.63.36-1.44.15-1.81-.49-.37-.64-.15-1.45.49-1.81l4.1-2.35c.88-.51.89-1.78 0-2.3l-4.11-2.38c-.63-.37-.85-1.18-.48-1.81.37-.64 1.17-.85 1.81-.49l4.11 2.36c.88.51 1.98-.13 1.98-1.15v-4.74c0-.73.59-1.32 1.32-1.32h.04c.73 0 1.32.59 1.32 1.32v7.8c0 .47.25.91.66 1.15l8.42 4.88c.88.51 1.99-.13 1.99-1.15v-9.76c0-.47-.25-.91-.67-1.15l-6.75-3.87c-.63-.36-.85-1.17-.49-1.8v-.02c.38-.64 1.19-.86 1.83-.49l4.1 2.37c.88.51 1.99-.13 1.99-1.15v-4.73c0-.73.59-1.32 1.32-1.32.73 0 1.32.59 1.32 1.32v4.73c0 1.02 1.11 1.66 1.99 1.15l4.1-2.37c.64-.37 1.45-.15 1.82.49v.02c.37.63.15 1.44-.48 1.8l-6.75 3.87c-.41.24-.67.67-.67 1.15v9.76c0 1.02 1.11 1.66 1.99 1.15l8.43-4.88c.41-.24.66-.67.66-1.15v-7.8c0-.73.59-1.32 1.32-1.32.73 0 1.32.59 1.32 1.32v4.74c0 1.02 1.1 1.66 1.98 1.15l4.12-2.37c.63-.36 1.43-.15 1.8.47v.02c.39.63.17 1.45-.46 1.82l-4.09 2.37c-.88.51-.88 1.79 0 2.3l4.1 2.35a1.323 1.323 0 0 1-1.31 2.3l-6.8-3.88c-.41-.23-.91-.23-1.32 0l-8.42 4.85c-.88.51-.88 1.79 0 2.3l8.42 4.85c.41.24.91.24 1.32 0l6.76-3.9c.63-.36 1.44-.15 1.81.48l.02.04c.37.64.15 1.45-.48 1.82l-4.09 2.35c-.88.51-.89 1.78 0 2.3l4.11 2.38c.63.37.85 1.18.48 1.81-.37.64-1.18.85-1.81.49l-4.14-2.39c-.88-.51-1.99.13-1.99 1.15v4.77c0 .73-.59 1.32-1.32 1.32-.73 0-1.32-.59-1.32-1.32v-7.8c0-.47-.25-.91-.66-1.15l-8.43-4.88c-.88-.51-1.99.13-1.99 1.15v9.73c0 .47.25.91.66 1.15l6.79 3.9a1.323 1.323 0 0 1-1.31 2.3l-4.15-2.37c-.88-.5-1.98.13-1.98 1.15v4.74c0 .73-.59 1.32-1.32 1.32-.73 0-1.32-.59-1.32-1.32Z"
			style={{
				fill: '#fff',
				stroke: '#fff',
				strokeMiterlimit: 10,
				strokeWidth: '.5px',
			}}
		/>
	</svg>
);

export default SvgLowTemp;
